import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface HeaderState {
  showBusinessSelector: boolean;
  currentRoute: string;
  isLoading: boolean;
  userRole: 'external';
}

const initialState: HeaderState = {
  showBusinessSelector: false,
  currentRoute: '/',
  isLoading: false,
  userRole: 'external'
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setShowBusinessSelector: (state, action: PayloadAction<boolean>) => {
      state.showBusinessSelector = action.payload;
    },
    setCurrentRoute: (state, action: PayloadAction<string>) => {
      state.currentRoute = action.payload;
      // Automatically determine business selector visibility based on route
      state.showBusinessSelector = action.payload !== '/';
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setUserRole: (state, action: PayloadAction<'external'>) => {
      state.userRole = action.payload;
    },
    resetHeader: (state) => {
      state.showBusinessSelector = false;
      state.currentRoute = '/';
      state.isLoading = false;
      state.userRole = 'external';
    },
  },
});

export const {
  setShowBusinessSelector,
  setCurrentRoute,
  setLoading,
  setUserRole,
  resetHeader,
} = headerSlice.actions;

export default headerSlice.reducer;